import React, { type FC, type PropsWithChildren } from 'react';

import Card, { type CardElementProps } from '../../card/card';

export interface TemplateCardProps extends Omit<CardElementProps, 'tags' | 'text' | 'children' | 'divider'> {
  /** Allows the component to get additional styles. */
  className?: string;
  /** Checks if the TemplateCard is the hub link. */
  isTemplateHubLink?: boolean;
}

const TemplateCard: FC<PropsWithChildren<TemplateCardProps>> = ({
  className,
  label,
  link,
  media,
  heading,
  isTemplateHubLink,
}) => (
  <Card
    isFullCardLink
    shouldAnimateOnHover
    css={theme => ({
      label: 'templateCard',
      height: '100%',
      width: '100%',
      backgroundColor: isTemplateHubLink ? theme.colors.primaryTertiaryAccent : theme.colors.white,
      padding: '32px 24px',
      '[data-card-element="heading"]': {
        display: '-webkit-box',
        WebkitLineClamp: 2,
        // required so that descenders don't get cut off
        paddingBottom: '0.1em',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      },
    })}
    // eslint-disable-next-line @stylistic/jsx-sort-props
    className={className}
    data-testid="template-card-container"
  >
    {media && (
      <Card.Media
        {...media}
        css={theme => isTemplateHubLink && { backgroundColor: theme.colors.primaryTertiaryAccent }}
      />
    )}
    {media && <Card.Divider type={isTemplateHubLink ? 'fullBleedPrimary' : 'fullBleed'} />}
    {label && <Card.Label {...label} isAttribution={!isTemplateHubLink} />}
    {heading && <Card.Heading as="h2" heading={heading} variant={isTemplateHubLink ? 'headingS' : 'headingM'} />}
    {link?.final_url && <Card.Link {...link} isFullCardLink />}
  </Card>
);

export { TemplateCard };
export default TemplateCard;
